import { Footer } from 'components/footer'
import { Navbar } from 'components/navbar'
import { ReturnToDashboard } from 'components/return-to-dashboard'
import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'

export const Layout = () => {
	const location = useLocation()
	const denyList = ['/dashboard', '/enter-code', '/login', '/verification', '/forgot-password', '/reset-password', '/new-password-required']

	return (
		<>
			<Navbar />
			<main>
				<Outlet />
				{!denyList.includes(location.pathname) && <ReturnToDashboard />}
			</main>
			<Footer />
		</>
	)
}


export const LayoutWithoutReturnToDashboard = () => {
	return (
		<>
			<Navbar />
			<main>
				<Outlet />
			</main>
			<Footer />
		</>
	)
}